module.exports = __webpack_public_path__ + "img/ALSi6-Wave.32465628.png";